<template>
  <v-container fluid class="adaptable">
    <v-layout row class="relative-position">
      <v-flex xs12>
        <v-card-title>
          Clientes
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          v-model="clientes"
          :headers="columns"
          :search="search"
          :items="clientes"
          :pagination.sync="serverPagination"
          class="elevation-8"
        >
          <template v-slot:items="props">
            <tr
              :class="`theme--light cursor-pointer py-2`"
              class="pt-2"
              @dblclick="cargarCliente(props.item)"
            >
              <td key="Nombre">
                <div class="ellipsis">
                  {{ props.item.Nombre }}
                </div>
                <router-link :to="loadCliente(props.item, true)" :event="null" tabindex="-1" />
              </td>
              <td key="RazonSocial">
                <div class="ellipsis">
                  {{ props.item.RazonSocial }}
                </div>
                <router-link :to="loadCliente(props.item, true)" :event="null" tabindex="-1" />
              </td>
              <td key="Cif">
                <div class="ellipsis">
                  {{ props.item.Cif }}
                </div>
                <router-link :to="loadCliente(props.item, true)" :event="null" tabindex="-1" />
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            No se encuentran resultados para "{{ search }}".
          </v-alert>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-layout>
      <template>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark @click="addClient()">
              Añadir Nuevo Cliente
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Cliente</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Nombre" label="Nombre del cliente*" required />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.RazonSocial" label="Razon Social*" required />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Cif" label="Cif" required />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Domicilio" label="Domicilio" />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Estado" label="Estado*" required />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.CodigoPostal" label="Código Postal" />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Poblacion" label="Población" />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Provincia" label="Provincia" />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Pais" label="Pais" />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Telefono1" label="Telefono 1" />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Telefono2" label="Telefono 2" />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Fax" label="Fax" />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Email" label="Email" />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="cliente.Web" label="Web" />
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="cliente.DiasAcrptacionVistoBueno"
                      label="Dias de aceptación"
                    />
                  </v-col>
                </v-row>
              </v-container>
              <small>*campos obligatorios</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="red darken-1" text @click="dialog = false">
                Cancelar
              </v-btn>
              <v-btn color="green darken-1" text @click="saveCliente()">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Cliente',
  data () {
    return {
      serverPagination: {
        initial: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'Nombre',
        descending: true
      },
      total: 5,
      rowsPerPageOptions: [20, 50, 100, 150, 200],
      columns: [
        { text: 'Nombre', value: 'Nombre', sortable: true, align: 'left' },
        { text: 'RazonSocial', value: 'RazonSocial', sortable: true, align: 'left' },
        { text: 'Cif', value: 'Cif', sortable: true, align: 'left' }
      ],
      clientes: [],
      cliente: {},
      dialog: false,
      search: ''
    }
  },
  mounted () {
    this.getClients()
  },
  methods: {
    getClients () {
      this.axios
        .get(`${this.$apiUrl('clientes')}`, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(data => {
          for (let z = 0; z < data.data.length; z++) {
            this.clientes.push(data.data[z])
          }
        })
    },
    cargarCliente (props) {
      this.loadCliente(props)
    },
    loadCliente (cliente, getHref = false) {
      if (getHref) {
        let routeData = this.$router.resolve({
          name: 'ClientesEdit',
          params: { clienteProp: cliente.Codigo }
        })
        return routeData.resolved.fullPath
      } else {
        this.$router.push({ name: 'ClientesEdit', params: { clienteProp: cliente.Codigo } })
      }
    },
    addClient () {
      this.dialog = true
    },
    saveCliente () {
      this.axios
        .post(`${this.$apiUrl('clientes')}?clientes=${this.cliente}`, this.cliente, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then(response => {
          if (response.status === 201) {
            this.$notify({ message: 'Cliente creado correctamente' })
            this.clientes = []
            this.dialog = false
            this.getClients()
          }
        })
    },
    getColorClient (cliente) {
      let color = ''
      if (cliente.Estado === 'I') {
        color = 'red'
      } else if (cliente.Estado === 'A') {
        color = 'light-green'
      }
      return color
    }
  }
}
</script>

<style>
.adaptTable {
  margin-top: -9%;
  padding-right: 0%;
  padding-left: 0%;
}
</style>
